export const filterAzubiList = (filters, azubiList) => {
  const azubiListFilteredByStatus = filterByStatus(filters, azubiList)

  if (filters.courses.length > 0 || filters.modules.length > 0) {
    const filtered = azubiListFilteredByStatus.map(azubi => ({
      user: azubi.user,
      courses: getFilteredCourses(filters, azubi),
      filteredModules: filters.modules.filter(m =>
        azubi.courses.some(c => c.id === m.courseId && moduleIsInListFilteredByStatus(azubi, m, filters.status)),
      ),
    }))

    return filtered
  }

  return azubiListFilteredByStatus
}

const getFilteredCourses = ({modules, courses, status}, azubi) => {
  if (modules.length === 1 && courses.length > 0 && courses.some(c => c.id === modules[0].courseId)) {
    return azubi.courses.filter(
      course =>
        courses.some(c => c.id === course.id) &&
        modules.some(m => m.courseId === course.id && moduleIsInListFilteredByStatus(azubi, m, status)),
    )
  }
  if (modules.length > 0 || courses.length > 0) {
    return azubi.courses.filter(
      course =>
        courses.some(c => c.id === course.id) ||
        modules.some(m => m.courseId === course.id && moduleIsInListFilteredByStatus(azubi, m, status)),
    )
  }
  return []
}

export const filterByStatus = ({status, courses, modules}, azubiList) => {
  if (status) {
    const filteredList = []

    azubiList.forEach(azubi => {
      const azubiObject = {
        user: azubi.user,
        courses: [],
        modules: [],
      }

      azubi.courses.forEach(course => {
        if (modules.length > 0) {
          const modulesWithMatchingStatus = []

          course.modules.forEach(module => {
            if (module.status === status) {
              modulesWithMatchingStatus.push(module)
            }
          })

          if (modulesWithMatchingStatus.length > 0) {
            azubiObject.courses.push({...course, modules: modulesWithMatchingStatus})
            modulesWithMatchingStatus.map(module => azubiObject.modules.push(module))
          }
        } else if (courses.length > 0 && modules.length === 0) {
          if (course.status === status) {
            azubiObject.courses.push(course)
            course.modules.map(module => azubiObject.modules.push(module))
          }
        } else if (course.status === status || course.modules.find(module => module.status === status)) {
          const courseObj = {...course}
          courseObj.modules = courseObj.modules.filter(module => module.status === status)
          azubiObject.courses.push(courseObj)

          course.modules.forEach(module => {
            if (module.status === status) {
              azubiObject.modules.push(module)
            }
          })
        }
      })

      filteredList.push(azubiObject)
    })

    return filteredList
  }
  return azubiList
}

const moduleIsInListFilteredByStatus = (azubi, moduleFilter, status) => {
  if (status) {
    return azubi.modules.some(am => am.id === moduleFilter.id)
  }
  return true
}

export const removeFilter = (item, selectedFilters) => {
  let newFilters

  if (item.type === 'COURSE') {
    const newSelectedCourses = selectedFilters.courses.filter(course => item.id !== course.id)
    newFilters = {...selectedFilters, courses: newSelectedCourses}
  } else if (item.type === 'COURSE_MODULE' || item.type === 'FOLDER') {
    const newSelectedModules = selectedFilters.modules.filter(module => item.id !== module.id)
    newFilters = {...selectedFilters, modules: newSelectedModules}
  } else if (item.type === 'STATUS') {
    newFilters = {...selectedFilters, status: ''}
  }

  return newFilters
}
